export const menu = [
  {
    name: "产品",
    children: [
      {
        name: "敬在HRP",
        children: [
          {
            name: "HRP智慧管理平台",
            route: "/hprSystem?name=HRP智慧管理平台",
          },
          {
            name: "产品蓝图",
            route: "/hprSystem?name=产品蓝图",
          },
          { name: "平台概述", route: "/hprSystem?name=平台概述" },
          { name: "技术优势", route: "/hprSystem?name=技术优势" },
        ],
      },
      {
        name: "成本管理",
        children: [
          { name: "科室成本管理", route: "/department?name=科室成本管理" },
          {
            name: "诊次/床日成本核算",
            route: "/department?name=诊次/床日成本核算",
          },
          {
            name: "病种(DRG/DIP)",
            route: "/department?name=病种(DRG/DIP)成本管理",
          },
          { name: "成本管理", route: "/department?name=成本管理成本管理" },
          { name: " DRG成本分析", route: "/department?name=DRG成本分析" },
        ],
      },
      {
        name: "绩效考核管理",
        children: [
          { name: "全面绩效管理", route: "/Overall?name=全面绩效管理" },
          { name: "绩效二级分配", route: "/Overall?name=绩效二级分配" },
          { name: "疾病能力绩效", route: "/Overall?name=疾病能力绩效" },
        ],
      },
      {
        name: "预算·报销·专项·合同",
        children: [
          { name: "全面预算管理", route: "/bascm?name=全面预算管理" },
          { name: "费用报销管理", route: "/bascm?name=费用报销管理" },
          { name: "专项经费管理", route: "/bascm?name=专项经费管理" },
          { name: "合同管理", route: "/bascm?name=合同管理" },
        ],
      },
      {
        name: "财务管理",
        children: [
          { name: "会计核算", route: "/finance?name=会计核算" },
          { name: "收入管理", route: "/finance?name=收入管理" },
          { name: "支出管理", route: "/finance?name=支出管理" },
          { name: "资金监管", route: "/finance?name=资金监管" },
          { name: "电子发票管理", route: "/finance?name=电子发票管理" },
          {
            name: "自动对账与银医直联",
            route: "/finance?name=自动对账与银医直联",
          },
          { name: "电子会计档案", route: "/finance?name=电子会计档案" },
        ],
      },
      {
        name: "设备·资产管理",
        children: [
          {
            name: "智慧设备・资产管理平台",
            route: "/equipAssets?name=智慧设备・资产管理平台",
          },
          { name: "资产管理", route: "/equipAssets?name=资产管理" },
          { name: "设备管理", route: "/equipAssets?name=设备管理" },
          { name: "单机效益分析", route: "/equipAssets?name=单机效益分析" },
        ],
      },
      {
        name: "智慧供应链管理(SPD)",
        children: [
          { name: "物资管理", route: "/supplyChain?name=物资管理" },
          { name: "高值耗材管理", route: "/supplyChain?name=高值耗材管理" },
          { name: "低值耗材管理", route: "/supplyChain?name=低值耗材管理" },
          { name: "二级库管理", route: "/supplyChain?name=二级库管理" },
          { name: "药品管理", route: "/supplyChain?name=药品管理" },
          {
            name: "中药饮片溯源平台(TSD+)",
            route:
              "/supplyChain?name=中药饮片溯源平台" +
              `${encodeURIComponent("(TSD+)")}`,
          },
          { name: "试剂管理", route: "/supplyChain?name=试剂管理" },
          {
            name: "电子采购平台(供应商协同)",
            route: "/supplyChain?name=电子采购平台(供应商协同)",
          },
        ],
      },
      {
        name: "人力资源管理",
        children: [
          { name: "组织人事", route: "/humanResources?name=产品概述" },
          { name: "排班考勤", route: "/humanResources?name=产品概述" },
          { name: "薪酬社保", route: "/humanResources?name=产品概述" },
          { name: "招聘培训", route: "/humanResources?name=产品概述" },
          { name: "职称评审", route: "/humanResources?name=产品概述" },
          { name: "人力360", route: "/humanResources?name=产品概述" },
        ],
      },
      {
        name: "运营数据中心",
        children: [{ name: "ODR系统", route: "/odrSystem?name=产品概述" }],
      },
      {
        name: "国产化信创适配认证",
        children: [
          { name: "产品概述", route: "/adaptationCert?name=产品概述" },
          /*  { name: "相关证书", route: "/adaptationCert?name=产品概述1" }, */
        ],
      },
    ],
  },

  {
    name: "解决方案",
    children: [
      { name: "医疗集团管理", route: "/medicalGroupManager?name=业务概述" },
      { name: "医共体管理", route: "/medicalCommunityManagement?name=产品概述" },
      {
        name: "卫生经济分析与监管",
        route: "/medicalGroupSanitation?name=业务概述",
      },
      { name: "单体医院", route: "/singleHospital?name=业务概述" },
    ],
  },
  {
    name: "AI智慧管理",
    route: "/AISmartManagement"
  },
  { name: "客户案例", route: "/customerCase" },
  { name: "生态伙伴", route: "/partner" },
  { name: "服务支持", route: "/serviceSupport" },
  {
    name: "关于敬在",
    children: [
      { name: "公司简介", route: "/company" },
      { name: "分支机构", route: "/branch" },
      { name: "资质荣誉", route: "/qualificationHonor" },
      { name: "敬在的观点与优势", route: "/viewpointsAdvantages" },
      { name: "新闻动态", route: "/newsInformation" },
      { name: "人才招聘", route: "/job" },
    ],
  },
];
